import type { Stripe } from "@stripe/stripe-js";
import { TFunction } from "../../generated/localisation";

export function guardStripe(t: TFunction, stripe?: Stripe | null): asserts stripe is Stripe {
  if (stripe == null) {
    throw new Error(t("lib.stripeProviderNotLoaded") ?? '');
  }
}
